import { createAsyncAction, createAction } from "typesafe-actions";
import { SensorDataFile, SensorDataFileRow } from "@shared/models";
import {
  Filter,
  PaginatedResponse,
  SensorDataFileFilter,
  SensorDataFileValueFilter,
  WithCallback,
} from "@shared/interfaces";

import { SensorDataFileActionTypes } from "./constants";

export const getSensorDataFiles = createAsyncAction(
  SensorDataFileActionTypes.GET_SENSOR_DATA_FILES,
  SensorDataFileActionTypes.GET_SENSOR_DATA_FILES_SUCCESS,
  SensorDataFileActionTypes.GET_SENSOR_DATA_FILES_FAILURE,
)<SensorDataFileFilter, PaginatedResponse<SensorDataFile>, Error>();

export const getSensorDataFile = createAsyncAction(
  SensorDataFileActionTypes.GET_SENSOR_DATA_FILE,
  SensorDataFileActionTypes.GET_SENSOR_DATA_FILE_SUCCESS,
  SensorDataFileActionTypes.GET_SENSOR_DATA_FILE_FAILURE,
)<{ id: number }, SensorDataFile | null, Error>();

export const getSensorDataFileValues = createAsyncAction(
  SensorDataFileActionTypes.GET_SENSOR_DATA_FILE_VALUES,
  SensorDataFileActionTypes.GET_SENSOR_DATA_FILE_VALUES_SUCCESS,
  SensorDataFileActionTypes.GET_SENSOR_DATA_FILE_VALUES_FAILURE,
)<SensorDataFileValueFilter & { id: number }, { rows: SensorDataFileRow[] }, Error>();

export const createSensorDataFile = createAsyncAction(
  SensorDataFileActionTypes.CREATE_SENSOR_DATA_FILE,
  SensorDataFileActionTypes.CREATE_SENSOR_DATA_FILE_SUCCESS,
  SensorDataFileActionTypes.CREATE_SENSOR_DATA_FILE_FAILURE,
)<WithCallback<{ data: FormData }>, SensorDataFile, Error>();

export const setFilter = createAction(SensorDataFileActionTypes.SET_FILTER)<Filter | null>();
export const setCurrentFileValuesFilter = createAction(
  SensorDataFileActionTypes.SET_CURRENT_FILE_VALUES_FILTER,
)<SensorDataFileValueFilter | null>();

export const clearSensorDataFile = createAction(SensorDataFileActionTypes.CLEAR_SENSOR_DATA_FILE)();
export const clearSensorDataFiles = createAction(SensorDataFileActionTypes.CLEAR_SENSOR_DATA_FILES)();
export const setFilePercentage = createAction(SensorDataFileActionTypes.SET_FILE_UPLOADING_PERCENTAGE)<number | null>();
